import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import EditableInfo from "../../EditableInfo";
import { useAppSelector } from "@builder/store/store";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { SmartTileNode } from "@common/build/types";
import { EditableProps } from "../../editableProps";
import ProductQuery from "../Query/ProductQuery";

const EditCategoryTile = ({ condition }: EditableProps) => {
    const cvMode = useAppSelector(state => state.builder.conditionalVariationMode);
    const selectedNode = useAppSelector(getSelectedNode) as SmartTileNode;

    if (condition && !condition(selectedNode, cvMode)) return null;

    return (
        <SidebarCollapse title="Setup">
            <EditableInfo header="categoryTileInfo1" paragraphs={["categoryTileInfo2", "categoryTileInfo3"]} />
            <ProductQuery noWrapper path={["query"]} excluded={["category"]} />
        </SidebarCollapse>
    );
};

export default EditCategoryTile;
